module.exports = __webpack_public_path__ + "./assets/icons/921785662PastryCook.webp";